import script from "./show.vue?vue&type=script&setup=true&lang=js"
export * from "./show.vue?vue&type=script&setup=true&lang=js"

import "./show.vue?vue&type=style&index=0&id=6e423b3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e423b3a"]])

export default __exports__